
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26 26"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#50585B","stroke-width":"1.1","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M3.582 18.74v3.13m20.883-9.391h-9.39v3.13h9.39v-3.13zm-7.309 0v3.13m5.22-3.13v3.13m1.034.001h-9.391v3.13h9.39v-3.13zm-7.306 0v3.13m5.218-3.13v3.13m3.143 0h-9.39v3.13h9.39v-3.13zm-7.309 0v3.13m5.22-3.13v3.13m1.034 0h-9.391V25h9.39v-3.13zm-7.306 0V25m5.218-3.13V25M10.89 18.74H1.5v3.13h9.39v-3.13zm-2.089 0v3.13m3.144 0H2.554V25h9.39v-3.13zm-2.09 0V25m-5.219-3.13V25M2.015 14.565l9.39-9.391 5.218 4.173L24.449 1"}}),_c('path',{attrs:{"d":"M17.156 1h7.304v6.782"}})])])
          )
        }
      }
    